import React from 'react';

export default function HomeFooter() {
    return (
        <footer className="bg-green-800 text-white py-4">
            <div className="container mx-auto px-4 text-center text-sm">
                <p>&copy; 2025 PermitTree - DENR-PENRO. All rights reserved.</p>
            </div>
        </footer>
    );
}
